import {Injectable}               from '@angular/core';
import {AgriportConstantsService} from '../common/agriport-constants.service';
import {FertilizerStore}          from '../../stores/base-data/fertilizer.store';
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import INSensorLogHeaderData = Data.Import.INSensorLogHeaderData;
import IDataSet = Data.Import.IDataSet;

@Injectable({providedIn: 'root'})
export class LogfileService {
  constructor(private fertilizationStore: FertilizerStore) {
  }

  public getPlanning(dataItem: IDatasetFieldMap, planBooks: INFertilizationPlanBook[]): INFertilizationPlanBook {
    if (!dataItem?.DataSet?.Created) {
      return undefined;
    }
    const headerValues: INSensorLogHeaderData = JSON.parse(dataItem.DataSet.HeaderValuesString);
    if (headerValues?.AgentContent === undefined || headerValues?.AgentContent === null || headerValues?.AgentContent === '') {
      return undefined;
    }
    const contentNDelta = +AgriportConstantsService.GetConstant('CONTENT_N_DELTA');
    const agent = +headerValues.AgentContent.Split(' ')[0].Replace(',', '.');
    if (!planBooks?.length) {
      return undefined;
    }
    return planBooks
      .filter((pb) => {
        return pb.DeletedBy == null &&
          pb.FieldGeomId === dataItem.FieldGeomId &&
          pb.LogFileOperationMode === headerValues.OperationMode &&
          agent - contentNDelta <= this.getContentN(pb) && agent + contentNDelta >= this.getContentN(pb) &&
          Math.abs(new Date(pb.ApplicationDate).valueOf() - new Date(dataItem.DataSet.Created).valueOf()) <
          +AgriportConstantsService.GetConstant('PLAN_DATE_DELTA') * 24 * 60 * 60 * 1000;
      })
      .sort((pb) =>
        Math.abs(this.getContentN(pb) - this.getNContentFromDataset(dataItem.DataSet)) * 1000 +
        Math.abs(new Date(pb.ApplicationDate).valueOf() - new Date(dataItem.DataSet.Created).valueOf())
      )
      .FirstOrDefault();
  }

  private getContentN(planBook: INFertilizationPlanBook): number {
    if (planBook?.ProductId == null) {
      return 0;
    }
    // Product Id = 0 means Pure Nutrient N (Reinnährstoff)
    if (planBook?.ProductId === 0) {
      return 100;
    }
    const fertilizer = this.fertilizationStore.getFertilizer(planBook.ProductId);
    if (!fertilizer?.ContentN) {
      return 0;
    }
    return (fertilizer.IsLiquid ? fertilizer.ContentN * fertilizer.Density : fertilizer.ContentN);
  }

  private getNContentFromDataset(dataset: IDataSet): number {
    const agentContent = dataset.HeaderValues['AgentContent'];
    if (agentContent) {
      return +agentContent.split(' ')[0].replace(',', '.');
    }
    return 0;
  }

  public calculateLogFileProductfromAmountNPerHa(rate: number | null, area: number, fertContentPercent: number | null): number | undefined {
    if (fertContentPercent == null || rate == null) {
      return undefined;
    }
    const fertilizerContent = fertContentPercent / 100;
    if ( fertilizerContent == null) {
      return undefined;
    }
    if (fertContentPercent === 0) {
      return 0.0;
    }
    if (!area) {
      area = 0.0;
    }
    return rate * area / fertilizerContent;
  }

  public calulateLogFileAmountNPerHaFromProduct(product: number | null, area: number , fertContentPercent: number | null): number | undefined {
    if ( fertContentPercent == null || product == null) {
      return undefined;
    }
    const fertilizerContent = fertContentPercent / 100;
    if (!area) {
      return 0;
    }
    return product * fertilizerContent / area;
  }

  public calculateLogFileAmountNFromProduct( product: number | null, fertContentPercent: number | null): number | undefined {
    if ( fertContentPercent  == null || product == null) {
      return undefined;
    }
    const fertilizerContent = fertContentPercent / 100;
    return product * fertilizerContent;
  }

  public calculateLogFileProductFromAmountN( rate: number | null, fertContentPercent: number | null): number | undefined {
    if (!fertContentPercent || rate == null) {
      return undefined;
    }
    const fertilizerContent = fertContentPercent / 100;
    if (!fertilizerContent){
      return undefined;
    }
    return rate / fertilizerContent;
  }
  public calulateLogFileFactor(userAmount: number | null,  rate: number | null, area: number, fertContentPercent: number | null): number {
    if (!fertContentPercent || !rate || !area || userAmount == null) {
      return 1.0;
    }
    const logFileAmount = this.calculateLogFileProductfromAmountNPerHa(rate, area, fertContentPercent);
    if (!logFileAmount) {
      return 1.0;
    }
    return userAmount / logFileAmount;
  }
}
